import React from 'react';
import { FadeUp } from './FadeUp';
export function Differentiator() {
  const tags = ['✅ Verified real users', '🇺🇸 U.S.-based database', '🔒 100% account safe', '⚡ Fast activation', '🎯 Natural-looking engagement', '📈 Measurable results', '🤝 Personalized support'];
  return <section id="diferencial" className="relative z-10 text-center py-[72px] md:py-[100px]" data-id="element-70">
      <div className="max-w-[900px] mx-auto px-6" data-id="element-71">
        <FadeUp data-id="element-72">
          <div className="bg-gradient-to-br from-cyan/5 to-transparent border border-cyan/40 rounded-md p-10 md:p-[64px_48px] relative overflow-hidden" data-id="element-73">
            {/* Top Glow inside wrapper */}
            <div className="absolute top-[-80px] left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-[radial-gradient(ellipse,rgba(0,229,255,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-74" />

            <span className="inline-block text-[11px] font-heading font-bold tracking-[0.25em] uppercase text-cyan mb-4" data-id="element-75">
              Why Profumind?
            </span>
            <h2 className="text-[clamp(26px,4vw,36px)] font-heading font-bold uppercase leading-[1.2] tracking-[0.05em] max-w-[600px] mx-auto mb-6" data-id="element-76">
              Premium infrastructure.
              <br data-id="element-77" />
              <span className="text-cyan" data-id="element-78">U.S.-based.</span> Built for
              credibility.
            </h2>
            <p className="text-white-dim text-base max-w-[560px] leading-[1.7] mx-auto mb-12" data-id="element-79">
              We operate with advanced systems that generate interaction in a
              natural, credible, and sustained way — exactly the way Instagram
              expects to see it.
            </p>

            <div className="flex flex-wrap gap-3 justify-start" data-id="element-80">
              {tags.map((tag, i) => <span key={i} className="bg-cyan/5 border border-cyan/10 rounded-sm px-[22px] py-2.5 text-[12px] font-heading font-semibold uppercase tracking-[0.05em] text-white transition-all duration-250 ease-in hover:border-cyan hover:text-cyan hover:shadow-[0_0_15px_rgba(0,229,255,0.15)]" data-id="element-81">
                  {tag}
                </span>)}
            </div>
          </div>
        </FadeUp>
      </div>
    </section>;
}